"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_switch_1 = __importDefault(require("react-switch"));
var Switch = function (_a) {
    var config = _a.config, checked = _a.checked, onChange = _a.onChange;
    return (0, jsx_runtime_1.jsx)(react_switch_1.default, __assign({ onColor: "#7F56D9", offColor: "#F2F4F7", handleDiameter: 20, uncheckedIcon: false, checkedIcon: false, activeBoxShadow: "", height: 26, width: 44, checked: checked, onChange: onChange }, config));
};
exports.Switch = Switch;
